const rupiah = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0,
})

const number = new Intl.NumberFormat('id-ID')

const compact = new Intl.NumberFormat('id-ID', {
  notation: 'compact',
  maximumFractionDigits: 1,
})

const date = new Intl.DateTimeFormat('id-ID', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

export function formatMoney(value) {
  const parsed = Number(value ?? 0)
  return rupiah.format(Number.isFinite(parsed) ? parsed : 0).replace(/\s/g, '')
}

export const formatCurrency = formatMoney

export function formatNumber(value) {
  const parsed = Number(value ?? 0)
  return number.format(Number.isFinite(parsed) ? parsed : 0)
}

export function formatCompact(value) {
  const parsed = Number(value ?? 0)
  return compact.format(Number.isFinite(parsed) ? parsed : 0)
}

export function formatDate(value, fallback = '—') {
  if (!value) return fallback
  const parsed = new Date(value)
  return Number.isNaN(parsed.getTime()) ? fallback : date.format(parsed)
}

export function formatTimeRemaining(value) {
  if (!value) return null
  const target = new Date(value).getTime()
  if (Number.isNaN(target)) return null
  const diffMs = target - Date.now()
  if (diffMs <= 0) return 'Telah berakhir'
  const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24))
  if (days === 1) return '1 hari tersisa'
  if (days < 30) return `${days} hari tersisa`
  const months = Math.floor(days / 30)
  const remDays = days % 30
  return remDays > 0 ? `${months} bln ${remDays} hr tersisa` : `${months} bulan tersisa`
}

export function formatRate(value) {
  return `${formatMoney(value)} / 1K views`
}

export function maskAccount(value) {
  const raw = String(value ?? '').replace(/\s/g, '')
  if (!raw) return '****'
  return `**** **** ${raw.slice(-4).padStart(4, '*')}`
}

export function humanizeStatus(value) {
  const labels = {
    DRAFT: 'Draft',
    PENDING: 'Menunggu',
    PENDING_REVIEW: 'Menunggu review',
    PROCESSING: 'Diproses',
    REVISION_REQUIRED: 'Perlu revisi',
    APPROVED: 'Disetujui',
    ACTIVE: 'Aktif',
    PAUSED: 'Dijeda',
    COMPLETED: 'Selesai',
    REJECTED: 'Ditolak',
    ARCHIVED: 'Dihapus / Diarsipkan',
    DELETED: 'Dihapus',
    IN_PROGRESS: 'Dikerjakan',
    SUBMITTED: 'Penayangan',
    PENAYANGAN: 'Penayangan',
    UNDER_REVIEW: 'Sedang ditinjau',
    VALIDATED: 'Tervalidasi',
    PAID: 'Dibayar',
    CANCELLED: 'Dibatalkan',
    VERIFIED: 'Terverifikasi',
    UNVERIFIED: 'Belum verifikasi',
  }
  return labels[value] || String(value || '—').replaceAll('_', ' ').toLowerCase()
}
